import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthMocksService } from "./mocks/auth-mocks.service";

interface IUser {
  userId: string;
  personId: number;
  email: string;
  firstName: string;
  lastName: string;
  middleName: string;
  suffix: string;
  beginDate: string;
  endDate: string;
  credentialHolder: boolean;
  credentialHolderExpiredGracePeriod: boolean;
  status: string;
  hasBadPayment: boolean;
  invalidCRTDate: boolean;
  instance: string;
  subjectToCMP: boolean;
  revokedCRT: boolean;
  hasExpiredCredentials: boolean;
  provisional: boolean;
  hasRT: boolean;
  underNBRCJE: boolean;
  hasHoursAndCanRecertify: boolean;
}
export class User implements IUser {
  userId = null;
  personId = null;
  email = null;
  firstName = null;
  lastName = null;
  middleName = null;
  suffix = null;
  beginDate = null;
  endDate = null;
  credentialHolder = false;
  credentialHolderExpiredGracePeriod = false;
  status = null;
  hasBadPayment = false;
  invalidCRTDate = false;
  instance = null;
  subjectToCMP = null;
  revokedCRT = false;
  hasExpiredCredentials = false;
  provisional = false;
  hasRT = false;
  underNBRCJE = false;
  hasHoursAndCanRecertify = false;
}

@Injectable()
export class UserService {
  private _currentUser: User;
  user$: BehaviorSubject<User>;

  constructor(private authMocks: AuthMocksService) {
    this.user$ = new BehaviorSubject(this._currentUser);
  }

  get CurrentUser() {
    return this._currentUser;
  }

  get isCurrentUserMock() {
    if (!this._currentUser) return false;
    return this._currentUser.userId == this.authMocks.user.userId;
  }

  get isCurrentUserInactive() {
    if (!this._currentUser) return true;
    return this._currentUser.status === "I";
  }

  clearActiveUser() {
    this._currentUser = null;
    this.user$.next(this._currentUser);
  }

  setActiveUser(user: User) {
    this._currentUser = user;
    this.user$.next(this._currentUser);
  }
}
